let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dck2g")).then(() => parcelRequire('32dr6'));